import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { injectTranslations } from '@lang';
import { required, validInteger } from '@utils/validators';
import { TableForm } from './TableForm';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { entitySelectors } from '@store/entity/selectors';

const getSelectedTimeSlot = (timeSlots, time) => {
  if (!timeSlots || !time) {
    return null;
  }
  return timeSlots.find((slot) => slot.timeSlot === time);
};
const isPromotionRequired = (timeslot) => timeslot && !timeslot.hasStandardAvailability;

const validate = (values, { timeSlots = [] }, t) => {
  const timeslot = getSelectedTimeSlot(timeSlots, values.timeslot);
  const errors: { [key: string]: string } = {
    restaurant: required(values.restaurant),
    visitDate: required(values.visitDate),
    timeslot: required(values.timeslot),
    promotionId: isPromotionRequired(timeslot) ? required(values.promotionId) : null,
    ...(values.guests
      ? {
          guests: required(values.guests.adults) || validInteger(values.guests.adults),
        }
      : {}),
  };

  if (values.hasDietaryRequirements) {
    if (!values.dietaryRequirements || values.dietaryRequirements.length === 0) {
      errors.dietaryRequirements = t('tables.dietaryRequirementError');
    }
  }

  if (values.hasCelebrationOptions) {
    if (!values.celebrationOptions || values.celebrationOptions.length === 0) {
      errors.celebrationOptions = t('tables.celebrationOptionsError');
    }
  }

  return errors;
};

const selector = formValueSelector('tableForm');

const mapDispatchToProps = (dispatch) => ({
  changeJourneyParam: (param, value) => changeJourneyParam(param, value)(dispatch),
});

const mapStateToProps = (state) => {
  return {
    property: entitySelectors.getProperty(state),
    guests: selector(state, 'guests'),
    visitDate: selector(state, 'visitDate'),
    startDate: selector(state, 'startDate'),
    timeslot: selector(state, 'timeslot'),
    promotion: selector(state, 'promotion'),
    restaurant: selector(state, 'restaurant'),
    note: selector(state, 'note'),
    hasDietaryRequirements: selector(state, 'hasDietaryRequirements'),
    hasCelebrationOptions: selector(state, 'hasCelebrationOptions'),
  };
};

const TableFormContainer = reduxForm({
  form: 'tableForm',
  validate: (values, props: any) =>
    validate(values, { ...props, timeSlots: props.timeSlots }, props.t),
})(TableForm as any);

export const TableFormReduxContainer: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectTranslations(TableFormContainer as any));
